import { Typography } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px;
`;

export const Title = styled(Typography)`
  text-align: left;
  text-transform: inherit;
  font-size: 24px;
  margin: 10px;
  font-weight: 500;
  font-family: Roboto;
  width: auto;
  color: #2b2727;
`;

export const Documents = styled.div`
  display: flex;
`;

export const DocumentWrapper = styled.div`
  margin-right: 16px;
`;
